import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
} from "@mui/material";
import { useState } from "react";

const SelectPopover = ({ children, options, onChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <div
        aria-describedby={id}
        onClick={handleClick}
        style={{ padding: "4px 0" }}
      >
        {children}
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List
          sx={{
            maxWidth: "200px",
            minWidth: "200px",
            maxHeight: "240px",
            overflowY: "auto",
          }}
        >
          {options.map((i) => {
            return (
              <ListItem
                disablePadding
                onClick={() => {
                  setAnchorEl(null);
                  onChange(i);
                }}
              >
                <ListItemButton>
                  <ListItemText
                    primary={i.label}
                    slotProps={{
                      primary: {
                        fontFamily: "Poppins, serif",
                        fontSize: "14px",
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Popover>
    </>
  );
};

export default SelectPopover;
